export const defaultSettings = {
  speed: 500,
  slidestoshow: 1,
  spaceBetween: 20,
  autoplay: false,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    400: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 1.8,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    800: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    960: {
      slidesPerView: 3.25,
      spaceBetween: 20,
    },
    1120: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    1380: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
}

export const featuredItemsSettings = {
  speed: 1500,
  slidestoshow: 1,
  spaceBetween: 10,
  autoplay: true,
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
  },
}

export const itemImagesSettings = {
  speed: 500,
  slidestoshow: 1,
  spaceBetween: 10,
  autoplay: false,
  loop: false,
  // rewind: true,
  direction: 'vertical' as 'vertical' | 'horizontal',
  breakpoints: {
    0: {
      slidesPerView: 1,
      direction: 'horizontal',
    },
    768: {
      slidesPerView: 3,
      direction: 'vertical',
    },
  },
}

export const itemListSettings = {
  speed: 1500,
  slidestoshow: 3.33,
  spaceBetween: 20,
  autoplay: false,
  loop: false,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 1.8,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    700: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    850: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    960: {
      slidesPerView: 3.25,
      spaceBetween: 20,
    },
    1120: {
      slidesPerView: 3.33,
      spaceBetween: 20,
    },
  },
}
